import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { Options } from "ngx-google-places-autocomplete/objects/options/options";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { Subject } from "rxjs";
import * as CONSTANT from "../../services/constants";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ExcelService } from "src/app/services/excel.service";
import { AngularFireDatabase } from "@angular/fire/compat/database";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Location, LocationStrategy } from "@angular/common";
import { APP_BASE_HREF } from "@angular/common";
import { environment } from "../../../environments/environment";
import { HttpBackend, HttpClient, HttpParams } from "@angular/common/http";
import { ImageUrls } from "src/app/services/s3buket";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { element } from "protractor";
import { chatEnvironment } from "src/environments/chatEnvironment";


@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.css"]
})
export class SearchComponent implements OnInit {
  filterOptions: any;
  totalJobCount: any;
  skillData: any = [];
  filterPersonalityOptions: any = [];
  addedSkills: any = [];
  resultData: any = [];
  selectedFilters: any = this._filterObject;
  totalresultDataCount: number = 0;
  Exclude_Candidate: any = CONSTANT.Exclude_Candidate;
  Languages: any = CONSTANT.Languages.sort((a, b) => a.name.localeCompare(b.name));
  options: Options = new Options({
    bounds: undefined, strictBounds: false,
    componentRestrictions: { country: "US" }
  });
  language: any = [];
  messageList: any = [];
  // closeSearch = false;
  search = "";
  searchObserver = new Subject<string>();
  allJobs: any = []
  allJobsList: any = []
  resultSkill: any = [];
  location = "";
  distance = "";
  latitude = "";
  longitude = "";
  queryFilters;
  filterNotApplicable: boolean = false
  showError: boolean = false
  showLocationError: boolean = false
  showDistanceError: boolean = false
  showWorkAuthorizationOptions: boolean = false;
  showPersonalities: boolean = false;
  showVaternStatus:boolean = false;
  links;
  form: FormGroup;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users;
  //modal box
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  noteData: any;
  // social link
  public link: string = "";
  environment = environment.apiUrl;
  user: any;
  // mail
  mailSendForm: FormGroup;
  mailForwardForm: FormGroup;
  templateData: any = [];
  actionType: any;
  userName: any;
  jobtitles: any;
  searchResults: any = [];
  subCategory: any = [];
  showSubCategory: boolean = false;
  showErrorSubCategory: boolean = false;
  currentPage: any;
  pagination = { limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: "" };
  firebaseUsers = chatEnvironment.users;
  firebaseMessage = chatEnvironment.messages;
  firebaseChats = chatEnvironment.chats;
  firebaseJobs = chatEnvironment.jobs;
  firebaseNotification = chatEnvironment.notifications;
  willingToRelocateCount:any = {
    yes: 0,
    no: 0
  };
  workAuthorizationOptions = [
    {
      key: 0,
      name: 'No',
      count: 0
    },
    {
      key: 1,
      name: 'Green card',
      count: 0 
    },
    {
      key: 2,
      name: 'EAD',
      count: 0 
    },
    {
      key: 3,
      name: 'H1B Visa',
      count: 0 
    },
    {
      key: 4,
      name: 'Citizen',
      count: 0 
    }
  ];
  currentPagejobList=1;
  paginationList = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  SelectId;
  selectedUser:any=[];
  selectedUserRemove;
  select: boolean = false;
  selectedUserData = null;
  @ViewChild('autoSearch', { read: ElementRef, static: false }) autoSearch: ElementRef | undefined;
  constructor(private modalService: BsModalService, private formBuilder: FormBuilder, private api: AdminService, private router: Router, private activateRoute: ActivatedRoute, private toastrService: ToastrService, private excelService: ExcelService, private locations: Location, private locationStrategy: LocationStrategy, @Inject(APP_BASE_HREF) private baseHref: string, private http: HttpClient, private handler: HttpBackend, private db: AngularFireDatabase, private afAuth: AngularFireAuth) {
    this.form = this.formBuilder.group({
      id: [""],
      userId: [""],
      status: [""],
      note: ["", Validators.compose([Validators.minLength(3), Validators.maxLength(2000)])]
    })
    this.mailSendForm = this.formBuilder.group({
      userId: ["", Validators.compose([Validators.required])],
      toEmail: ["", Validators.compose([Validators.required, Validators.pattern(CONSTANT.EMAIL_REGEX)])],
      subject: ["", Validators.compose([Validators.required])],
      isType: [""],
      message: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(2000)])]
    })
    this.mailForwardForm = this.formBuilder.group({
      userId: ["", Validators.compose([Validators.required])],
      toEmail: ["", Validators.compose([Validators.required, Validators.pattern(CONSTANT.EMAIL_REGEX)])],
      jobTitle: ["", Validators.compose([Validators.required])],
      subject: ["", Validators.compose([Validators.required])],
      candidate: ["", Validators.compose([Validators.required])],
      isType: [""],
      message: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(2000)])]
    })
  }
  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe(params => {
      console.log("params", params);
      if (params) {
        if (params.filters) {
          var x = JSON.parse(params.filters);
        
          Object.keys(x).forEach((pkey) => {
            if (x.longitude) {
              this.longitude = x.longitude;
            }
            if (x.latitude) {
              this.latitude = x.latitude;
            }
            Object.keys(this.selectedFilters).forEach((fkey) => {
              if (pkey == fkey) {
                this.selectedFilters[fkey] = x[pkey];
                if (pkey == 'search') {
                  console.log("11111")
                  this.search = x[pkey];
                } else if (pkey == 'location') {
                  this.location = params['location'];
                } else if (pkey == 'distance') {
                  this.distance = params['distance'];
                }
              }
            })
           
          })
  
          this.getSearchData(true);
          
        } else{
          if (params['search']) {
            this.search = params['search'];
            if (params['location'])
              this.location = params['location'];
            if (params['distance'])
              this.distance = params['distance'];
              this.getSearchData(true);
          }
         
        }
        
      }

    });
    this.getFilterOptions();
    this.getSixTeenPersonality();
    this.searchObserver.pipe(
      debounceTime(100),
      distinctUntilChanged())
      .subscribe(value => {
        if (value == "") {
          this.allJobs = [];
        } else {
          this.getAutoSearch();
        }
      });
  }
  // getAutoSearch
  getAutoSearch() {
    let params = new HttpParams();
    params = params.append("skip", 1);
    params = params.append("limit", 10);
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    this.api.showLoader = false
    this.api.loader(false);
    this.api.postData(apiUrl._autoCompleteSearch, params)
      .subscribe(async (res) => {
        this.allJobs = res.data.hits.hits;
        console.log("this.allJobs", this.allJobs)
      })
  }

  onTextChange(value: any) {
    this.search = value;
    if (this.search.length > 1) {
      this.getAutoSearch();
      // console.log("this.search.length", this.search.length)
      // this.api.setSearch(this.search);
      // this.searchObserver.next(this.search)
    } else {
      this.search = '';
      this.allJobs = [];
    }
  }
  // get current location 

  getLatLongFromZipCode(location: string) {
    fetch("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.location + "&key=AIzaSyCDi96O9BAjbJUHBC-DTtw4QNmo3ekxIgA")
      .then(response => response.json())
      .then(data => {
        console.log(data, 'data');
        if (data.results == "") {
          this.showLocationError = true
        }
        for (let j = 0; j < data.results[0].address_components.length; j++) {
          if (data.results[0].address_components[j].types.includes("postal_code") || data.results[0].address_components[j].types.includes("locality")) {
            this.location = data.results[0].address_components[j].long_name;
            this.latitude = data.results[0]?.geometry.location.lat.toString();
            this.longitude = data.results[0]?.geometry.location.lng.toString();
            if (this.search != "") {
              this.getSearchData(true);
              this.filterNotApplicable = true;
              this.showError = false;
            } else {
              this.filterNotApplicable = false;
              this.showError = true;
              setTimeout(() => {
                this.showError = false;
              }, 1000);
            }
          }
        }
      })
  }
  // search function
  searchFun() {
    this.currentPage = 1
    this.autoSearch?.nativeElement.classList.remove('show')
    this.resultData = []
    if (this.location == "" && this.distance == "") {
      delete this.selectedFilters.location;
      delete this.selectedFilters.latitude;
      delete this.selectedFilters.longitude;
      delete this.selectedFilters.distance;
      if (this.search != "") {
        this.getSearchData(true);
        this.filterNotApplicable = true;
        this.showError = false;
      } else {
        this.filterNotApplicable = false;
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 1000);
      }
    } else if (this.location != "" && this.distance != "") {
      this.getLatLongFromZipCode(this.location)
    } else if (this.location != "" && this.distance == "") {
      // show distance error
      this.showDistanceError = true
      setTimeout(() => {
        this.showDistanceError = false;
      }, 1000);
    } else if (this.location == "" && this.distance != "") {
      // SHOW ZIP ERROR
      this.showLocationError = true
      setTimeout(() => {
        this.showLocationError = false;
      }, 1000);
    }
  }
  refreshPage() {
    this.filterNotApplicable = false;
    this.search = "";
    this.allJobs = [];
    this.api.setSearch(this.search);
  }
  // get skill
  getSixTeenPersonality() {
    this.api.getDatas(apiUrl._sixTeenPersonality).subscribe((res) => {
      console.log(res, '_sixTeenPersonality');
      this.filterPersonalityOptions = res.data.rows;

    })
  }
  getFilterOptions() {
    this.api.getDatas(apiUrl._getAllCommon).subscribe((res) => {
      this.filterOptions = res.data;
      this.filterOptions.jobtitle = [];
      this.filterOptions.category = [];
      this.filterOptions.travelRequirement = [];
      this.filterOptions.workPlace = [];
      this.filterOptions.securityClearance = [];
      this.filterOptions.employmentTypes = [];
      this.filterOptions.education = [];
      this.filterOptions.Languages = [];
      this.filterOptions.industry = [];
     // this.skillData = res.data.skills;
     // this.skillData.splice(0, 0, { name: "Enter" });
     // this.filterOptions.personalities.rows = this.filterOptions?.personalities?.rows.sort((a, b) => a.title > b.title ? 1 : -1) || [];
    })
  }
  getSubcate(catID) {
    let catId = catID
    let params = new HttpParams();
    params = params.append("categoryId", catId);
    this.api.getData(apiUrl._getSubCategories, params).subscribe((res) => {
      this.subCategory = res.data.data;
    })
  }

  // selected Skill
  selectedSkill(event) {
    if (event.target.value == 0) return;
    this.addedSkills.push(this.skillData[event.target.value]);
    this.skillData.splice(event.target.value, 1);
    event.source.blur();
  }

  // selected Skill
  selectedResumeUpdated(event) {
    if (event.target.value == 0) return;
    this.selectedFilters.resumeLastUpdate = event.target.value;
  }
  // remove Skill
  removeSkills(i) {
    this.addedSkills.splice(i, 1)
  }
  // work type 
  onFilterOptionChange(event, option, type) {
    if(!this.selectedFilters[type]) {
      this.selectedFilters[type] = [];
    }
    if (type == "categoryId") {
      this.selectedFilters[type] = [];
      this.showSubCategory = false;
      this.selectedFilters["specializationId"] = [];
    }
    if (event.target.checked) {
      if (type == "categoryId") {
        this.showSubCategory=true;
        this.selectedFilters['specializationId'] = [];
      }
      if (type == "education" || type == "language" || type == "workAuthorization" || type == "workPlace") {
        this.selectedFilters[type].push(option.key);
      } else if (type == "language") {
        this.selectedFilters[type].push(option.name);
      } else if (type == "personalityTest") {
        this.selectedFilters[type].push(option.title);
      } else {
        this.selectedFilters[type].push(option.id);
      }
      //if (type == "categoryId") {
       // this.getSubcate(option.id);
      //}
    } else {
      if (type == "education" || type == "language" || type == "workAuthorization" || type == "workPlace") { 
        this.selectedFilters[type] = this.selectedFilters[type].filter((x) => x !== option.key);
      } else {
        this.selectedFilters[type] = this.selectedFilters[type].filter((x) => type == "personalityTest" ? x !== option.title : x !== option.id);
      }
    }
    
    // this.refreshFilters();
    this.api.showLoader = false;
    this.getSearchData(false);
  }

  onWillingToRelocate(event) {
    this.selectedFilters.willingToRelocate = event.target.value;
    this.api.showLoader = false;
    this.getSearchData(false);
  }
  onWorkAuthorization(event, key) {
    let workAuthorization: any = []
    workAuthorization = event.target.value;
    this.selectedFilters.workAuthorization = workAuthorization;
    this.api.showLoader = false;
    this.getSearchData(false);
  }
  onAvailability(event) {
    if(event.target.checked) {
      this.selectedFilters.availability = Number(event.target.value);
    } else {
      delete this.selectedFilters.availability;
    }
    this.api.showLoader = false;
    this.getSearchData(false);
  }
  onWorkExperiences(event) {
    this.selectedFilters.workExperiences = Number(event.target.value);
  }
  onSalaryRate(event) {
    this.selectedFilters.rate = event.target.value;
  }
  onCompanyName(event) {
    this.selectedFilters.companyName = event.target.value;
  }
  onSalary(event) {
    this.selectedFilters.salary = Number(event.target.value);
  }

  refreshFilters() {
    this.router.navigate(["/search/" + this.selectedFilters.search], { queryParams: { filters: this.filtersIntoString } })
    // this.resetJobsAndGetSearch();
  }
  get filtersIntoString() {
    // var request = Object.keys(this.selectedFilters).
    // filter((key) => this.selectedFilters[key] instanceof Array ? this.selectedFilters[key].length > 0 : this.selectedFilters[key] != null).
    // reduce((cur, key) => { return Object.assign(cur, { [key]: this.selectedFilters[key] }) }, {});
    // return
    var request = Object.keys(this.selectedFilters).
      filter((key) => this.selectedFilters[key] instanceof Array ? this.selectedFilters[key].length > 0 : this.selectedFilters[key] != null).
      reduce((cur, key) => { return (key == "minimum" || key == "maximum") ? Object.assign(cur, { [key]: parseInt(this.selectedFilters[key]) }) : Object.assign(cur, { [key]: this.selectedFilters[key] }) }, {});
    return JSON.stringify(request);
  }
  getSearchData(resetFilters) {

    // this.api.stopLoader();
    // let searchSplit : any = [];
    // this.search.split(",").map((searchKeyWords) => {
    //   if(searchKeyWords != "")
    //   searchSplit.push(searchKeyWords.trim());
    //   })
    //   if(searchSplit.length == 0) {
    //     this.resultData=[]
    //     return
    //   }
    // this.jobtitles = searchSplit.toString();
    // this.resultSkill = searchSplit;
    this.selectedFilters.search = this.search;
    if (this.location != "" && this.distance > "0" && this.distance != "") {
      this.selectedFilters.location = this.location;
      this.selectedFilters.latitude = this.latitude;
      this.selectedFilters.longitude = this.longitude;
      this.selectedFilters.distance = Number(this.distance);
    }
   /* if (this.addedSkills != "") {
      let skillIds: any = []
      this.addedSkills.map((skill) => {
        skillIds.push(skill.id)
      })
      this.selectedFilters.skillId = skillIds;
    } else {
      delete this.selectedFilters.skillId
    } */
    var request = Object.keys(this.selectedFilters).
      filter((key) => this.selectedFilters[key] instanceof Array ? this.selectedFilters[key].length > 0 : this.selectedFilters[key] != null).
      reduce((cur, key) => { return Object.assign(cur, { [key]: this.selectedFilters[key] }) }, {});
    request["limit"] = this.pagination.limit.toString()
    request["skip"] = this.currentPage ? this.currentPage:1
    //if (request["workAuthorization"]) {
     // request["workAuthorization"] = [Number(request["workAuthorization"])]
   // }
   /*
    if (request["categoryId"] && !request["specializationId"]) {
      this.showErrorSubCategory = true;
      setTimeout(() => {
        this.showErrorSubCategory = false;
      }, 1000);
      return
    } else {
      this.showErrorSubCategory = false;
    } */
    //this.resultData = [];
    this.api.postData(apiUrl._recruiterSearch, request).subscribe((res) => {
      this.totalresultDataCount = res.data.hits.total.value;
      this.pagination.totalItems = res.data.hits.total.value;
      if((resetFilters) && (res.data.aggregation)) {
        this.resetFilterOptions(res.data.aggregation, true)
      } else if (this.showSubCategory) {
        this.resetFilterOptions(res.data.aggregation, false)
      }
      // this.onSaveSearchResult(this.totalresultDataCount);
      if (res.data.hits.hits != "") {
        //this.resultData = [...this.resultData, ...res.data.hits.hits];
        this.resultData = res.data.hits.hits || [];
        this.resultData.map((user) => {
          let pastWork: any = [];
          let currentWork = null;
          if (user?._source?.workExperience) {
            user?._source?.workExperience.map((workType) => {
              if (workType?.isCurrentlyRole == 0 || workType?.currently == 0) {
                pastWork.push(workType)
              } else {
                currentWork = workType
              }
            })
            user["pastWork"] = pastWork;
            user["currentWork"] = currentWork;
          }
          // this.environment + apiUrl._getJobsUser +"/"+this.jobID+"/"+user.id;
          this.user = user.id;
          this.environment + apiUrl._getJobsUser + "/" + user.id + "/" + user.id;
          // this.link= window.location.href 
        })
        
        
        this.filterNotApplicable = true;
      } else {
        this.resultData = []
        this.filterNotApplicable = false;
      }
    })
  } 
  resetFilterOptions(lists, loadAll): void {
    // if(!this.filterOptions){
    //   this.filterOptions = {} 
    // }
    if(loadAll) {
      this.skillData = lists.skills || [];
      this.showVaternStatus = false;
      if(this.filterOptions){
      this.filterOptions?.vaternStatus.forEach(element => {
        lists?.veteranRelationType.some(v1 => {
        if(element.id == v1.id)
          element.count = v1.count;
          if(element.count > 0) {}
            this.showVaternStatus = true;
        });
      });
      this.filterOptions.jobtitle = lists?.jobTitle || [];
      this.filterOptions.category = lists?.categories || [];
      // this.subCategory = lists.subCategories || [];
      this.filterOptions.travelRequirement = lists?.travelRequirements || [];
      this.filterOptions.workPlace = lists?.workPlace || [];
      this.filterOptions.securityClearance = lists?.securityClearance || [];
      //this.filterOptions.employmentTypes = lists.employmentTypes || [];
      this.filterOptions?.employmentTypes.forEach(element => {
        lists?.employmentTypes.some(et => {
        if(element.id == et.id)
          element.count = et.count;
        });
      });
      this.filterOptions.industry = lists?.industries || [];
      this.filterOptions.education = lists?.education || [];
      this.filterOptions.Languages = lists?.language || [] 
      }
      this.showWorkAuthorizationOptions = false;
      this.workAuthorizationOptions.forEach(element => {
        element.count = 0
        lists?.workAuthorization.some(et => {
            if(element.key == et.key) {
              this.showWorkAuthorizationOptions = true;
              element.count = et.doc_count;
            }
          });
      }); 
      
      lists?.willingToRelocate.some(wrl => {
        if(wrl.key == 0) {
          this.willingToRelocateCount.no = wrl.doc_count;
        };
        if(wrl.key == 1) {
          this.willingToRelocateCount.yes = wrl.doc_count;
        };
      });
      this.showPersonalities = false;
      if(lists.personalities) {
        this.filterPersonalityOptions.forEach(async (element) => {
          element.count = 0;
          await lists.personalities.forEach(k1 => {
            if(k1.key.toLowerCase() === element.title.toLowerCase())  {
              element.count = k1.doc_count;
              if(k1.doc_count > 0) {
                this.showPersonalities = true;
              }
            }
          });
        });
      } 
      this.showSubCategory = false; 
      this.subCategory = [];
    } else {
      this.showSubCategory = true; 
      this.subCategory = lists.subCategories || [];
    }
  }
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getSearchData(false);
  }
  // dateago
  totalExperience(data) {
    let totalYears = 0
    let totalMonths = 0
    data.pastWork.map((work) => {
      totalYears += this.dateDiffCalculator(work?.fromDate, work?.toDate)["years"];
      totalMonths += this.dateDiffCalculator(work?.fromDate, work?.toDate)["months"];
    })

    while (totalMonths > 11) {
      totalYears += 1;
      totalMonths -= 12;
    }

    return totalYears == 0 ? totalMonths + " months" : totalMonths == 0 ? totalYears + " years" : totalYears + " years " + totalMonths + " months"
  }

  dateDiffCalculator(fromDate, toDate): any {
    if (fromDate != null && toDate != null) {
      var startDate: any = new Date(fromDate);
      var endDate: any = new Date(toDate);
      var diffDate: any = new Date(endDate - startDate);
      return { "years": (diffDate.toISOString().slice(0, 4) - 1970), "months": diffDate.getMonth() }
    }
  }

  dateAgo(fromDate, toDate) {
    if (fromDate != null && toDate != null) {
      var startDate: any = new Date(fromDate);
      var endDate: any = new Date(toDate);
      var diffDate: any = new Date(endDate - startDate);
      return ((diffDate.toISOString().slice(0, 4) - 1970) + " years " + diffDate.getMonth() + " months ");
    } else {
      return "NA"
    }
  }
  toggleFilterChekbox(optionId, key) {
    console.log(this.selectedFilters)
    return this.selectedFilters[key].indexOf(optionId) == -1 ? false : true;
  }
  applyFilter() {
    this.currentPage = 1
    this.getSearchData(false);
  }
  onClearFilters() {
    this.selectedFilters = this._filterObject;
    this.addedSkills = []
    this.getSearchData(true);
    this.showSubCategory = false;
    let body = document.querySelectorAll(".accordion-drawer__trigger");
    for (let i = 0; i < body.length; i++) {
      let data = body[i] as HTMLInputElement
      data.checked = false;
    }
  }
  get _filterObject() {
    return {
      latitude: null,
      longitude: null,
      limit: 10,
      skip: 1,
      search: [],
      location: null,
      distance: null,
      companyName: null,
      resumeLastUpdate: null,
      salary: null,
      rate: null,
      willingToRelocate: null,
      workExperiences: null,
      availability: null,
      language: [],
      vaternStatus: [],
      industryName: [],
      skillId: [],
      jobTitleId: [],
      specializationId: [],
      jobPreferenceId: [],
      travelRequirementId: [],
      categoryId: [],
      securityClearanceId: [],
      employementTypeId: [],
      education: [],
      personalityTest: [],
      excludeCandidate: [],
      workPlace: [],
      workAuthorization: []
    };
  }
  onModalScrollDown() {
    // this.selectedFilters.skip = this.selectedFilters.skip + 1; 
    // this.getSearchData();
  }
  onSaveSearchResult(totalresultDataCount) {
    let searchSplit: any = [];
    this.search.split(",").map((searchKeyWords) => {
      searchSplit.push(searchKeyWords.trim());
    })
    this.resultSkill = searchSplit;
    const data = {
      search: searchSplit,
      resultCount: totalresultDataCount
    }
    this.api.postData(apiUrl._saveSearchResult, data).subscribe((res) => {
    })
  }
  onSaveSearch(event, totalresultDataCount) {
    let searchSplit: any = [];
    this.search.split(",").map((searchKeyWords) => {
      searchSplit.push(searchKeyWords.trim());
    })
    this.resultSkill = searchSplit;
    const data = {
      search: searchSplit,
      resultCount: totalresultDataCount
    }
    this.api.postData(apiUrl._saveSearch, data).subscribe((res) => {
      this.toastrService.success("", "Search Saved successfully");
    })
  }
  // check if only number
  preventNumbers(event): boolean {
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // open model
  open(sendMail: TemplateRef<any>, data) {
    this.mailSendForm.patchValue({
      userId: data.id,
      toEmail: data.email,
      isType: 1,
    })
    this.getTemplate();
    this.modalRef = this.modalService.show(
      sendMail,
      Object.assign({}, this.config, { class: "modal-lg addModal" })
    );
  }

  getTemplate() {
    let params = new HttpParams();
    params = params.append("skip", '1');
    params = params.append("limit", '100');
    this.api.getData(apiUrl._getTemplate, params)
      .subscribe(async (res) => {
        this.templateData = res.data.data;
        this.templateData.map((actionName) => {
          if (actionName.action == 1) {
            actionName['actionType'] = "Shortlisted"
          } else if (actionName.action == 2) {
            actionName['actionType'] = "Rejected"
          } else if (actionName.action == 3) {
            actionName['actionType'] = "On Hold"
          } else if (actionName.action == 4) {
            actionName['actionType'] = "BV not cleared"
          } else if (actionName.action == 5) {
            actionName['actionType'] = "Hired"
          }

        })
      })
  }

  onTemplateTypeSelect(event) {
    if (event.target.value == -1) {
      this.mailSendForm.patchValue({
        subject: "",
        message: "",
      })
    } else {
      this.mailSendForm.patchValue({
        subject: this.templateData[event.target.value].subject,
        message: this.templateData[event.target.value].description,
      })
    }
  }

  onSendMail() {
    if (this.mailSendForm.valid) {
      this.api.postData(apiUrl._toMailSend, this.mailSendForm.value).subscribe(res => {
        this.modalRef?.hide()
        this.mailSendForm.reset()
        this.toastrService.success("", "Mail sent successfully!")
      })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
    }
  }
  // open model
  openModal(forwordMail: TemplateRef<any>, data) {
    this.userName = data.name
    this.mailForwardForm.patchValue({
      userId: data.id,
      jobTitle: this.jobtitles,
      candidate: data.email,
      isType: 1,
    })
    this.modalRef = this.modalService.show(
      forwordMail,
      Object.assign({}, this.config, { class: "modal-md addModal" })
    );
  }
  onForwardMail() {
    if (this.mailForwardForm.valid) {
      this.api.postData(apiUrl._forwardMail, this.mailForwardForm.value).subscribe(res => {
        this.modalRef?.hide()
        this.mailForwardForm.reset()
        this.toastrService.success("", "Mail Forward Successfully!")
      })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
    }
  }
  // mail me

  mailMe() {
    var mail = document.createElement("a");
    const subject = "Your Profile is Short-listed"
    mail.href = "mailto:" + this.links + "subject=" + subject + "&body=Hi";
    mail.click();
  }

  // add fav
  addFav(event, number, data) {
    console.log(data);
    let id: any
    id = data
    let favourite;
    let text;
    if (number == 0) {
      favourite = 1;
      text = "<p>Are you sure you want to mark this user favourite?</p>";
    } else {
      favourite = 0;
      text = "<p>Are you sure you want to mark this user un-favourite?</p>";
    }
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "userId": id,
          "favourite": favourite,
        }
        this.api.postData(apiUrl._addFavourite, data).subscribe(res => {
        })
      }
    });
  }
  // hide
  hideUser(id, index) {
    let text = "<p>Are you sure you want to hide this user?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "userId": id,
        }
        this.api.postData(apiUrl._getHide, data).subscribe(res => {
          this.resultData.splice(index, 1);
          this.totalresultDataCount -= 1;
        })
      }
    });
  }
  //save note
  noteStatus(event, data, addMore: TemplateRef<any>) {
    this.noteData = data;

    this.form.patchValue({
      id: this.noteData.id,
      userId: this.noteData?.userId,
      status: this.noteData?.status,
      note: this.noteData?.note,
    })
    this.modalRef = this.modalService.show(
      addMore,
      Object.assign({}, this.config, { class: "modal-sm addModal" })
    );
  }
  onSubmit() {
    const data = {
      "userId": this.noteData.id,
      // "userId": this.noteData.userId, 
      "note": this.form.value.note,
      "status": this.form.value.status,
    }
    this.api.putData(apiUrl._statusUpdate, data).subscribe(res => {
      this.toastrService.success("", "Note Sent Successfully!");
      this.modalRef?.hide();
    })
  }

  downloadUser(data) {
    let excelData: any = [];
    let allData = data;
    let skillData: any = []
    allData.userSkillDetails.map((skill) => {
      skillData.push(skill.skills?.name)
    })
    let workdata = ""
    allData.user_work_experiences.map((work) => {
      workdata = workdata == "" ? work.companyName : workdata + "," + work.companyName
    })
    let edudata: any = []
    allData.userEducationDetails.map((edu) => {
      edudata.push(edu.university?.name)
    })
    const record = {
      LastVisit: allData?.lastVisit,
      Name: allData?.name,
      Location: allData?.location,
      profileImage: allData?.profileImage,
      work_experiences: workdata,
      Education: edudata,
      SkillDetails: skillData,
    }
    // dataToSend.push(record)
    excelData = [record];
    this.excelService.exportAsExcelFile(excelData, "user");

  }

  onDownlaod(id) {
    const data = {
      userId: id,
    }
    this.api.postData(apiUrl._downloadRecruiterResume, data).subscribe(
      pdf => {
        window.open(pdf.data.url);
        this.modalRef?.hide();
      },
      err => {
        console.log("err->", err);
      }
    );
  }

  // goToChat(id:any){
  //   this.router.navigate(["/message/message-detail/"+ id])
  // }

  goToDetail(id) {
    let queryparams = {}
    queryparams["search"] = this.search;
    if (this.location != "")
      queryparams["location"] = this.location;
    if (this.distance != "")
      queryparams["distance"] = this.distance;
    if (this.filtersIntoString != "")
      queryparams["filters"] = this.filtersIntoString;
    this.router.navigate(["search/detail/" + id], { queryParams: queryparams })
  }

  setSearchText(searchItem) {
    this.search = searchItem?._source.name ? searchItem?._source.name : searchItem?._source.searchKey
    this.allJobs = []
    this.autoSearch?.nativeElement.classList.remove('show')
  }

  //chat job view
  openChatJobView(template: TemplateRef<any>,data){
    this.selectedUserData = data;
    console.log(data,'data');
    this.getJobs()
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal" })
    );
  }
  
  getJobs(){
    let params = new HttpParams(); 
    params = params.append("skip", this.currentPagejobList);
    params = params.append("limit", this.paginationList.limit.toString()); 
    this.api.stopLoader();
    this.api.getData(apiUrl._getJobsListing,params)
      .subscribe(async (res) => {
        this.paginationList.totalItems = res.data.count; 
        this.totalJobCount = res.data.count; 
        this.allJobsList = res.data.listing; 

      })
  }
  pageChangedList(event: any): void {
    // if (event == this.currentPagejobList) return;
    this.currentPagejobList = event;
    this.paginationList.skip = (event - 1) * this.paginationList.limit; 
    window.scroll(0, 0);
    this.getJobs();
  }
  
userSelect(event,int) {
  this.allJobsList.map((job) => {
    job['IsSelete'] = false;
  })
  this.allJobsList[int].IsSelete=event.target.checked
  
  if(event.target.checked){
    this.SelectId=this.allJobsList[int].id 
    this.selectedUser=this.allJobsList[int] 
 }else{
   this.SelectId='';
 } 
 this.openChatView(this.selectedUserData)
  
}
  //chat
  openChatView(data) {    
    this.modalService.hide();
    var job_id = this.SelectId;
    var user_id = data._source?.id;
    var user_pic = data._source?.profileImage;
    var user_name = data._source?.name;
    var company_name = this.selectedUser?.recruiter?.companyName;
    var company_pic = this.selectedUser?.recruiter?.profileImage;
    var chatDiologId = this.SelectId+','+data._source?.id;
    /////////////////////////
    var userNameArr = {};
    userNameArr[job_id] = company_name;
    userNameArr[user_id] = data._source?.name;

    var blockStatus = {};
    blockStatus[job_id] = 0;
    blockStatus[user_id] = 0;

    let unread_count = {}
    unread_count[job_id] = 0;
    unread_count[user_id] = 0;

    var clearChatTime = {};
    clearChatTime[job_id] = new Date().getTime();
    clearChatTime[user_id] = new Date().getTime();

    //////////////////
    var lastMessageArr = {};
    lastMessageArr[job_id] = '';
    lastMessageArr[user_id] = '';

    var picArr = {};
    picArr[job_id] = company_pic ? company_pic : "";
    picArr[user_id] = data._source?.profileImage ? data._source?.profileImage : "";
    this.db.list(`${this.firebaseChats}`,
    query => query
        .orderByChild("chat_dialog_id")
        .equalTo(chatDiologId)
        .limitToLast(10)
    ).valueChanges().subscribe(list => {          
            this.messageList = list ? list : [];       
            if (list.length == 0) {        
              var chatDialog = this.db.object(`${this.firebaseChats}/${chatDiologId}`).set({
                "chat_dialog_id": chatDiologId.toString().trim(),
                "job_id": job_id,
                "user_id": user_id,          
                "name": userNameArr,
                "last_message_time": new Date().getTime(),
                "last_message_type": 0,
                "last_message_sender_id": user_id,
                "last_message": lastMessageArr,
                "last_message_id": '',
                "unread_count": unread_count,
                "block_status": blockStatus,
                "clear_chat_time": clearChatTime,
                "user_name":user_name,
                "job_pic":company_pic,
                "pic":picArr,
                "company_name":company_name
              });
             
              let dialogArr = {}
              dialogArr[chatDiologId] = chatDiologId;
              var chatDialog11212 = this.db.object(`${this.firebaseUsers}/${user_id}`).update({
                  "chat_dialog_ids" : dialogArr
              });
              var chatDialog112= this.db.object(`${this.firebaseUsers}/${job_id}`).update({
                  "chat_dialog_ids" : dialogArr
              });
              this.router.navigateByUrl('message/message-detail/' +job_id);
              // console.log('aa',chatDialog);
            } else {
              this.router.navigateByUrl('message/message-detail/' +job_id);
          }
    });
  } 
}
